import { render } from "./SSMKTeamLinks.vue?vue&type=template&id=5f336d05"
import script from "./SSMKTeamLinks.vue?vue&type=script&lang=js"
export * from "./SSMKTeamLinks.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__